import { Theme } from '@mui/material';
import { createUseStyles } from 'react-jss';

export type FlatButtonSize = 'x-small' | 'small' | 'medium';

export type FlatButtonColor = 'black' | 'grey' | 'link' | 'error' | 'light-grey';

export const getFlatButtonIconSize = (size: FlatButtonSize): FlatButtonSize =>
  size === 'medium' ? 'small' : size;

export const useFlatButtonStyles = createUseStyles((theme: Theme) => ({
  flatButton: {
    cursor: 'pointer',
    '&.link': {
      color: theme.palette.link.main,
    },
    '&.error': {
      color: theme.palette.error.main,
    },
    '&.black': {
      color: theme.palette.common.black,
    },
    '&.grey': {
      color: theme.palette.darkGray,
    },
    '&.light-grey': {
      color: theme.palette.gray,
    },
    '&.disabled': {
      cursor: 'default',
      color: theme.palette.darkGray,
    },
    '&:hover:not(.disabled) .MuiTypography-root': {
      textDecoration: 'underline',
    },
  },
}));
